module.exports = __webpack_public_path__ + "img/2021-06.f528341c.jpg";